// extracted by mini-css-extract-plugin
module.exports = {"anchor":"i_Hj"};